export default class ArticlesCarousel {
    constructor(element) {
        this.selector = element;

        this.initSlider();
    }

    async initSlider() {
        const target = this.selector.querySelector('[data-slider]');

        if (!target) {
            return;
        }

        const { default: Glide } = await import('@glidejs/glide');
        this.Glide = Glide;

        const slider = this.mountSlider();

        this.slidePrev(slider);
        this.slideNext(slider);
        this.resizeSlider(slider);
    }

    mountSlider() {
        return new this.Glide(this.selector, {
            type: 'slider',
            perView: this.getSlidesPerView(),
            animationDuration: 300,
            animationTimingFunc: 'ease-in-out',
            gap: this.getGapPerView(),
            bound: true,
            rewind: false,
        }).mount();
    }

    slidePrev(slider) {
        const button = this.selector.querySelector('[data-slider-button="prev"]');

        if (!button) {
            return;
        }

        button.addEventListener('click', () => {
            slider.go('<');
        });
    }

    slideNext(slider) {
        const button = this.selector.querySelector('[data-slider-button="next"]');

        if (!button) {
            return;
        }

        button.addEventListener('click', () => {
            slider.go('>');
        });
    }

    resizeSlider(slider) {
        let timeout;
        let prevWidth = window.innerWidth;

        window.addEventListener('resize', () => {
            const currentWidth = window.innerWidth;

            if (currentWidth === prevWidth) {
                return;
            }

            clearTimeout(timeout);
            timeout = setTimeout(() => {
                slider.update({
                    perView: this.getSlidesPerView(),
                    startAt: 0,
                    gap: this.getGapPerView(),
                });
                prevWidth = currentWidth;
            }, 300);
        });
    }

    getSlidesPerView() {
        if (window.innerWidth < 768) {
            return 1.5
        }

        if (window.innerWidth < 1024) {
            return 2.5;
        }

        return 4.5;
    }

    getGapPerView() {
        if (window.innerWidth < 768) {
            return 8
        }

        return 24;
    }
}